import UnPinIcon from './UnPinIcon';

export default UnPinIcon;
